import React, { useEffect, useMemo } from 'react';
import { SubNavigation } from '../SubNavigation/SubNavigation';

export interface NavigationMobileProps {
	navigationItems?: Navigation.NestedNavigationItem[];
	handleMobileNavLinkClick?: () => void;
}

const NavigationMobile: React.FC<NavigationMobileProps> = ({ navigationItems = [], handleMobileNavLinkClick }) => {
	// Reuse the SubNavigation
	const pseudoRoot = useMemo(
		() =>
			({
				name: 'Menu',
				title: 'Menu',
				decendants: navigationItems,
			} as unknown as Navigation.NestedNavigationItem),
		[navigationItems],
	);

	useEffect(() => {
		if (!handleMobileNavLinkClick) return;
		if (typeof window === 'undefined') return;

		const onLangPicked = () => handleMobileNavLinkClick();
		window.addEventListener('nav:languagePicked', onLangPicked);
		return () => window.removeEventListener('nav:languagePicked', onLangPicked);
	}, [handleMobileNavLinkClick]);

	return (
		<div>
			<SubNavigation root={pseudoRoot} onLeafNavigate={handleMobileNavLinkClick} />
		</div>
	);
};

export default NavigationMobile;
